import React, { useEffect } from 'react';
import callCancelledIcon from '../../images/request-cancelled.svg';
import callCancelledIconSmall from '../../images/request-cancelled-small.svg';

const SignUpCallRequestCancelled = () => {
  const isMobile = window.innerWidth < 768;

  useEffect(() => {
    setTimeout(() => {
      window.location.replace('/tor/contact/call');
    }, 3000);
  }, []);

  return (
    <div
      className="signup-form-container"
      style={{ alignItems: 'center' }}>
      <img src={isMobile ? callCancelledIconSmall : callCancelledIcon} />
    </div>
  );
};

export default SignUpCallRequestCancelled;



// WEBPACK FOOTER //
// ./src/components/NewSignUp/SignUpCallRequestCancelled.js